"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAN_SELECTION_NOT_PERMITTED_CODE = void 0;
exports.PLAN_SELECTION_NOT_PERMITTED_CODE = 'PLAN_SELECTION_NOT_PERMITTED';
//# sourceMappingURL=plan-selection-access.js.map